var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialWorkspaces({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF518") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WORKSPACE-LIBRARY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace-lib-3",
    transform: "translate(-37.000000, -348.000000)",
    fill: "#262262",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3407227,369.414212 C55.5835586,367.782013 60.273382,367.336702 62.5922699,367.214846 C63.3840161,367.173143 63.9994781,366.538456 63.9994781,365.777654 L63.9994781,349.941449 C63.9999356,349.111297 63.2799209,348.453629 62.4164891,348.502381 C59.8477544,348.648178 54.7421452,349.178817 51.5902667,351.108149 C51.3727837,351.241312 51.2495083,351.478021 51.2495083,351.725487 L51.2495083,368.781858 C51.2495083,369.3233 51.8415326,369.665478 52.3407227,369.414212 Z M49.7499696,368.785154 L49.7499696,351.717065 C49.7499696,351.469095 49.6271519,351.24177 49.4092111,351.108149 C46.2577904,349.178817 41.1521813,348.648636 38.5834465,348.502381 C37.7200148,348.453629 37,349.111297 37,349.941449 L37,365.778112 C37,366.539371 37.6154618,367.174059 38.4071622,367.215303 C40.7270114,367.337206 45.4192152,367.782975 48.6620053,369.416089 C49.1598221,369.666851 49.7499696,369.325131 49.7499696,368.785154 Z",
    id: "\\uF518"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialWorkspaces);
export default __webpack_public_path__ + "static/media/tutorial-workspaces.9f33cc4436db2ca700c2908007704d96.svg";
export { ForwardRef as ReactComponent };